import styled from 'styled-components';

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  box-sizing: border-box;
  padding: 2.3em 1em;
`;

const BreadCrumps = styled.div`
  margin-bottom: 39px;
  img {
    margin-right: 1.3em;
    transition: opacity 0.25s ease-in-out;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  span {
    font-size: 2.25em;
    color: ${props => props.theme.color.text};
  }
`;

const CenterContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 30px;
`;

const DataGeneralWrapper = styled.div`
  width: 100%;
  border: solid 1px ${props => props.theme.color.border};
  border-radius: 4px;
  margin-right: 30px;
`;

export { BreadCrumps, CenterContainer, Container, DataGeneralWrapper };
